import { gqlTagGira } from '@atlassian/jira-issue-fetch-services-common/src/services/issue-gira-data/gira-fragments/index.tsx';

// This gqlTagGira is a non-apollo usage tag that still generates types under '__generated_apollo__' folder
// https://hello.atlassian.net/wiki/spaces/JFP/pages/1889693782/Jira+Playbook+Graphql
export const ISSUE_NAVIGATOR_PLUGGABLE_ITEMS_QUERY = gqlTagGira`
  query IssueNavigatorPluggableItemsQuery($first: Int!) {
    jiraWebSection(input: { location: JIRA_NAVIGATOR }) {
      webItems(first: $first) {
        pageInfo {
          hasNextPage
        }
        totalCount
        nodes {
          id
          label
          tooltip
          iconUrl
          target {
            type
            addonKey
            moduleKey
            ...on JiraWebItemTargetDialogModule {
              targetKey
            }
          }
        }
      }
    }
  }
`;
